/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMobiledataOff = createReactComponent("outline", "mobiledata-off", "IconMobiledataOff", [["path", { "d": "M16 12v-8", "key": "svg-0" }], ["path", { "d": "M8 20v-8", "key": "svg-1" }], ["path", { "d": "M13 7l3 -3l3 3", "key": "svg-2" }], ["path", { "d": "M5 17l3 3l3 -3", "key": "svg-3" }], ["path", { "d": "M3 3l18 18", "key": "svg-4" }]]);

export { IconMobiledataOff as default };
//# sourceMappingURL=IconMobiledataOff.mjs.map
